module.exports = __webpack_public_path__ + "media/category_icons/PhysicianAssistant-a553f0ea.svg";